import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

import { LAST_URL } from 'consts';
import { useEpgStore } from 'hooks/common/useEpgStore';
import routes from 'routesPaths';

export function useScrollToTop() {
  const { epgStore } = useEpgStore();
  const { pathname } = useLocation();
  const navType = useNavigationType();
  const isEpg = pathname.includes(epgStore?.referenceId);

  useLayoutEffect(() => {
    const prevUrl = sessionStorage.getItem(LAST_URL) || '';

    if (
      !isEpg &&
      navType !== 'POP' &&
      !pathname.includes(routes.details.commonPath) &&
      !prevUrl.includes(routes.details.commonPath)
    ) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
}
